import { useQuery } from "@tanstack/react-query";
import { automationRunsService } from "services/admin/automationRunsService";

export const useGetAutomationContacts = (automationID: number) => {
    return useQuery({
        queryKey: ['automation-runs', automationID],
        queryFn: async () => {
            return await automationRunsService.getAllByAutomationID(automationID);
        },
    });
};